import styles from "./Notification.module.css";
import { updateDoc, doc } from "firebase/firestore";
import { useSelector } from "react-redux";
import db from "../../firebase";

const SingleNotification = ({ notifications, setNotifications, data }) => {
  const loggedUser = useSelector((state) => state.loggedUser);
  const dateFormat = (date) =>
    date.toDate().toLocaleDateString("en-IN").replaceAll("/", "-");

  const timeFormat = (time) => time.toDate().toLocaleTimeString("en-IN");

  const updateRead = () => {
    if (data.read_status) {
      return;
    }

    const temp = notifications.find((item) => item.id === data.id);
    temp.read_status = true;

    setNotifications(
      notifications.map((item) => (item.id === data.id ? temp : item))
    );

    updateDoc(doc(db, `user_data/${loggedUser.uid}/notifications`, data.id), {
      read_status: true,
    });
  };

  return (
    <>
      <div
        className={`${styles.singleNotification} ${
          !data.read_status && styles.unread
        }`}
        onClick={updateRead}
      >
        {data.msg}
        <div className={styles.singleNotificationTime}>
          <span>{dateFormat(data.time)}</span>{" "}
          <span>{timeFormat(data.time)}</span>
        </div>
      </div>
      <hr className={styles.divider} />
    </>
  );
};

export default SingleNotification;
